import { getStaffMemberById } from "@fp/admin-api-client/client";
import { PageContentContainer } from "@fp/ui/components/base/page-layout/page-layout";
import { AdminLayout } from "@/components/admin-layout";
import { AdminPageHeader } from "@/components/admin-page-header";
import {
  StaffForm,
  StaffFormActions,
  StaffFormContent,
} from "@fp/ui/components/staff/staff-form";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useCallback } from "react";

export const Route = createFileRoute("/staff/$id/edit")({
  loader: async ({ params }) => {
    const staffMember = await getStaffMemberById(params.id);
    return {
      staffMember: staffMember.data,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { staffMember } = Route.useLoaderData();
  const router = useRouter();

  const handleSuccess = useCallback(async () => {
    await router.invalidate();
    router.navigate({
      to: "/staff",
    });
  }, [router]);

  return (
    <AdminLayout>
      <AdminPageHeader
        title="Edit Staff Member"
        parent={{ url: "/staff", label: "Staff Members" }}
      />
      <PageContentContainer className="space-y-6 p-0">
        <StaffForm staffMember={staffMember} onSuccess={handleSuccess}>
          <StaffFormContent className="p-6 flex-grow" />
          <StaffFormActions className="bg-white py-6" />
        </StaffForm>
      </PageContentContainer>
    </AdminLayout>
  );
}